export default "__VITE_ASSET__Cc1ovEY7__"